import { AlertTriangle, BookOpen, CalendarCheck, MapPin } from 'lucide-react';

import type {
    DashboardNotificationCounts,
    DashboardNotificationItem,
    DashboardNotificationSeverity,
    DashboardNotificationSource,
} from '../../types';

// Groups are named after the page each notification comes from, so the bell, the notifications page
// and those pages use the same words.
export const NOTIFICATION_SOURCES = ['ATTENDANCE', 'HOMEWORK', 'MANUAL', 'STAFF'] as const;
export const NOTIFICATION_SEVERITIES = ['high', 'medium', 'low'] as const;

export const sourceLabels: Record<DashboardNotificationSource, string> = {
    ATTENDANCE: 'Buổi học',
    HOMEWORK: 'Bài tập về nhà',
    MANUAL: 'Cảnh báo cần theo dõi',
    STAFF: 'Nhật ký nhân sự',
};

export const sourceIcons = {
    ATTENDANCE: CalendarCheck,
    HOMEWORK: BookOpen,
    MANUAL: AlertTriangle,
    STAFF: MapPin,
} as const;

// Where the full list of each group lives.
export const sourcePages: Record<DashboardNotificationSource, string> = {
    ATTENDANCE: '/attendance',
    HOMEWORK: '/dashboard',
    MANUAL: '/dashboard',
    STAFF: '/staff-activity',
};

export const countKeys: Record<DashboardNotificationSource, keyof DashboardNotificationCounts> = {
    ATTENDANCE: 'attendance',
    HOMEWORK: 'homework',
    MANUAL: 'manual',
    STAFF: 'staff',
};

// Same labels as the "Buổi học" page and the manual alert board.
export const severityLabels: Record<DashboardNotificationSeverity, string> = {
    high: 'Cao',
    medium: 'Trung bình',
    low: 'Thấp',
};

export const severityDots: Record<DashboardNotificationSeverity, string> = {
    high: 'bg-danger-500',
    medium: 'bg-warning-500',
    low: 'bg-academy-500',
};

export const severityIconClasses: Record<DashboardNotificationSeverity, string> = {
    high: 'bg-danger-50 text-danger-700 ring-danger-100',
    medium: 'bg-warning-50 text-warning-700 ring-warning-100',
    low: 'bg-academy-50 text-academy-700 ring-academy-100',
};

export function bySource(items: DashboardNotificationItem[]) {
    const groups: Partial<Record<DashboardNotificationSource, DashboardNotificationItem[]>> = {};
    for (const item of items) (groups[item.source] ||= []).push(item);
    return groups;
}

export function countBySeverity(items: DashboardNotificationItem[] = []) {
    const counts: Record<DashboardNotificationSeverity, number> = { high: 0, medium: 0, low: 0 };
    for (const item of items) counts[item.severity] += 1;
    return counts;
}

export function formatNotificationTime(value: string, withDate = false) {
    return new Date(value).toLocaleString('vi-VN', {
        hour: '2-digit',
        minute: '2-digit',
        ...(withDate ? { day: '2-digit', month: '2-digit' } : {}),
        timeZone: 'Asia/Ho_Chi_Minh',
    });
}
